import React, { FormEventHandler } from 'react';

import { makeStyles } from '@material-ui/core';

import { FormProvider, UseFormReturn } from 'react-hook-form';

const useStyles = makeStyles(() => ({
  formStyle: {},
}));

interface FormProps {
  onSubmit: FormEventHandler<HTMLFormElement>;
  children: React.ReactNode;
  methods: UseFormReturn<any, any>;
}

const Form = ({ children, methods, onSubmit }: FormProps) => {
  const classes = useStyles();

  return (
    <form className={classes.formStyle} onSubmit={onSubmit}>
      <FormProvider {...methods}>{children}</FormProvider>
    </form>
  );
};

export default Form;
